module.exports = __webpack_public_path__ + "static/img/celoscope-detail-35.e4ae85b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-35.jpg
// module id = lFFX
// module chunks = 52